import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';

import { IUserIdentityConflict } from '../types/IUserIdentityConflict';

export interface IGetUserIdentityConflictsResult extends IGetItemsResult {
  userIdentityConflicts: IUserIdentityConflict[];
}

export class GetUserIdentityConflictsRequest extends Request<IGetItemsParams, IGetUserIdentityConflictsResult> {
  constructor(params: IGetItemsParams) {
    super('getUserIdentityConflicts', params);
  }
}
